import { EmailClientService } from '../service/email-client.service';
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Location } from '@angular/common';
import { forkJoin } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
@Component({
  selector: "outlook-email-client-detail",
  templateUrl: "./outlook-email-client-detail.component.html",
  styleUrls: ["./outlook-email-client-detail.component.scss"],
})
export class OutlookEmailClientDetailComponent implements OnInit {
  @Input('emailId') emailId: string = '';
  // @Input('emailType') emailType: string = '';
  @Output('eventType') eventType: EventEmitter<string> = new EventEmitter<string>();
  emailDetails: any;
  previousUrl: string = null;
  currentUrl: string = null;
  emailType:string;
  messageType:string;
  selUsername:string;
  replyDataList = [
    {
      name: "Reply",
      code: "reply",
    },
    {
      name: "Reply All",
      code: "replyAll",
    },
    {
      name: "Forward",
      code: "forward",
    },
  ];
  constructor(private location: Location,
    private toastr: ToastrService,
    private ngxService: NgxUiLoaderService,
    private emailClientService: EmailClientService) {
  }
  ngOnInit(): void {
    if (this.emailId) {
      this.getEmailDetails(this.emailId);
    }
    this.messageType = this.emailClientService.outlookMessageType;
    this.emailClientService.selectedEmailAccount
    this.selUsername = this.emailClientService.selectedUsername;
  }

  updateMessageReadFlag(){
    const message = {
      isRead: true,
    };
    this.emailClientService.updateMsgFlag(this.emailId,message).subscribe(data=>{
      console.log("updated message read flag.");
    })
  }

  onBack() {
    this.emailClientService.emailDetailSubscription$.next({ read: false });
    this.emailClientService.folderChangeSubject$.next(true);
  }

  onReplyChange(eventType:string) {
    this.emailClientService.emailDetailSubscription$.next(
      { read: false, emailId: (this.emailId || this.emailDetails[0]['id']), emailType: 'compose-mail', replyType: eventType });
      this.emailClientService.selectedEmailId = this.emailId || this.emailDetails[0]['id'];
      this.emailClientService.selectedReplyType = eventType;
      if(this.messageType==="Drafts"){
        this.emailClientService.preservedMessageTypeForDraft = this.messageType;
      }
  }

  onDownloadClick(contentType:any,file: File, name: string) {
    // const linkSource ='data:application/octet-stream;base64,' + file;
    const linkSource = `data:${contentType};base64,${file}`;
    const downloadLink = document.createElement('a');
    downloadLink.href = linkSource;
    downloadLink.download = name;
    downloadLink.click();
  }

  getEmailDetails(id: string) {
    const select = "body,from,sentDateTime,subject,ccRecipients,toRecipients,isRead";
    this.ngxService.start();
    forkJoin([
      this.emailClientService.getSingleEmail(id,select),
      this.emailClientService.getEmailAttachments(id)
    ]).subscribe((emailDetaiils: any) => {
      if (emailDetaiils) {
        console.log(emailDetaiils);
        this.emailDetails = emailDetaiils;
        if(!emailDetaiils[0].isRead){
          this.updateMessageReadFlag(); 
        }
        this.ngxService.stop();
      }
    },
      (error: any) => {
        this.ngxService.stop();
        this.onBack();
      }
    );
  }

  deleteEmail(id:string){
    let emailArr = Array.of({'id':id});
    this.emailClientService.isDeleteFromDetail= true;
    this.emailClientService.emailArrSubscription$.next(emailArr);
    this.onBack();       
  }
}